import { FC, forwardRef } from 'react';
import { TTextInput } from './text-input.types';
import { StyledInput } from './text-input.styles';

export const TextInput: FC<TTextInput> = forwardRef((props, ref) => (
    <StyledInput ref={ref} {...props} />
));

TextInput.displayName = 'TextInput';
